/* eslint-disable no-console */
import { register } from 'register-service-worker'
const debug = false

register(`${ process.env.BASE_URL }service-worker.js`, {
    ready() {
        if(debug) console.log(
            'App is being served from cache by a service worker.\n' +
            'For more details, visit https://goo.gl/AFskqB'
        )
    },
    registered() {
        if(debug) console.log('Service worker has been registered.')
    },
    cached() {
        if(debug) console.log('Content has been cached for offline use.')
    },
    updatefound() {
        if(debug) console.log('New content is downloading.')
    },
    updated() {
        if(debug) console.log('New content is available; please refresh.')
    },
    offline() {
        if(debug) console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
        if(debug) console.error('Error during service worker registration:', error)
    }
})
